import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCompass(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M10.265 11.639a2 2 0 0 0 1.374-1.374l1.867-6.534a1 1 0 0 0-1.237-1.236L5.735 4.36a2 2 0 0 0-1.374 1.374l-1.866 6.534a1 1 0 0 0 1.236 1.236z"
      />
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M9.333 8a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCompass);
export default ForwardRef;
